import { Link } from 'react-router';
import { Container, SectionHead } from '@/components/layout-primitives';
import { buttonBase } from '@/lib/bw';
import { useDocument } from '@/lib/use-document';
import { NOT_FOUND_ROUTE } from '@/lib/seo';

/**
 * What `notFound()` used to render.
 *
 * Reached two ways: an unmatched path, and the services routes while
 * SERVICES_ENABLED is false. Prerendered to dist/404.html so Vercel can serve
 * it as the real static 404 rather than rewriting unknown paths to the home
 * page with a 200.
 */
export function NotFound() {
  useDocument(NOT_FOUND_ROUTE);

  return (
    <main className="bg-white">
      <section className="bg-bw-cream py-16 md:py-24">
        <Container>
          <div className="flex flex-col items-center gap-8 text-center">
            <SectionHead
              as="h1"
              eyebrow="404"
              title="This page went out for butter"
              lead="It is not here, and we are not going to pretend otherwise. Head back to the home page and start again."
            />
            <Link to="/" className={`${buttonBase} bg-bw-yellow text-bw-ink`}>
              Back to the home page
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
}
